<mat-form-field2 class="mat-block" [showLabel]="showLabel">
  <app-select
    [items]="items$ | async"
    [formControl]="ctrl"
    bindLabel="name"
    bindValue="id"
    groupBy="type"
    [multiple]="multiple"
    [searchable]="true"
    [required]="ctrl | required"
    [placeholder]="placeholder"
    [disabled]="ctrl.disabled"
  >
  </app-select>
  <mat-error *ngIf="ctrl.touched && ctrl.hasError('required')">
    {{ placeholder }}&nbsp;<ng-container i18n>is required</ng-container>
  </mat-error>
</mat-form-field2>
